import { createContext } from 'react';

const NavigationContext = createContext(void 0);

NavigationContext.displayName = 'context(Navigation)';

export default NavigationContext;